import type { Notification, NotificationType } from "@/types/ui";
import { defineStore } from "pinia";
import { ref } from "vue";
import { v4 as uuidv4 } from "uuid";

export const useNotificationStore = defineStore("notification", () => {
    // State
    const notifications = ref<Notification[]>([]);

    // Actions
    function remove(notification: Notification) {
        notifications.value = notifications.value.filter(({ id }) => id !== notification.id);
    }

    function add({ text, type }: { text: string; type: NotificationType }) {
        let duration = 10000;
        switch (type) {
            case "success":
                duration = 5000;
                break;
            case "error":
                duration = 15000;
                break;
            default:
                break;
        }

        const notification: Notification = {
            id: uuidv4(),
            type,
            text,
            duration,
        };

        notifications.value.push(notification);

        setTimeout(() => {
            remove(notification);
        }, duration);
    }

    function addSuccess(text: string) {
        add({ type: "success", text });
    }

    function addWarning(text: string) {
        add({ type: "warning", text });
    }

    function addError(text: string, error?: any) {
        console.log(error);
        add({ type: "error", text });
    }

    return {
        notifications,
        add,
        addSuccess,
        addWarning,
        addError,
        remove,
    };
});